import { render, staticRenderFns } from "./month-import.vue?vue&type=template&id=0c0ab4d6&scoped=true&"
import script from "./month-import.vue?vue&type=script&lang=js&"
export * from "./month-import.vue?vue&type=script&lang=js&"
import style0 from "./month-import.vue?vue&type=style&index=0&id=0c0ab4d6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0ab4d6",
  null
  
)

export default component.exports